'use strict';

module.exports = text;

var u = require('unist-builder');
var trimLines = require('trim-lines');

/* Transform text. */
function text(h, node) {
  return h.augment(node, u('text', trimLines(node.value)));
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-html/~/mdast-util-to-hast/lib/handlers/text.js
// module id = 234
// module chunks = 96961042003272 139266963665775